let memoizedColumns = []
const ActivityLogColumn = () => {
    if (memoizedColumns.length > 0) {
        return memoizedColumns
    }
    memoizedColumns = [
        {
            accessorKey: 'checkbox',
            header: '',
        },
        {
            accessorKey: 'name',
            header: 'ID',
        },
        {
            accessorKey: 'mr_number',
            header: 'MR Number',
        },
        {
            accessorKey: 'client',
            header: 'Agency',
        },
        
       
    ]
    return memoizedColumns
}
export default ActivityLogColumn